import * as moment from 'moment';
import { CategorieArticle } from "./categorie-article";
import { TypeQuantite } from "./type-quantite";

export class Article {
    art_id: number;
    art_aca_id: number;
    art_atq_id: number;
    art_nde_id: number;
    art_tyr_code: string;
    art_code: string;
    art_libelle: string;
    art_prix_unitaire_ht: number;
    art_taux_tva: number;
    art_compte_comptable_societe: string;
    art_date_commit: Date;
    art_date_last_update: Date;
    art_etat: boolean;
    art_suppression: boolean;

    categorie?: CategorieArticle = null;
    typeQuantite?: TypeQuantite = null;

    constructor(init?) {
        if (!init) {
            return;
        }

        Object.assign(this, init);
        this.art_date_commit = init.art_date_commit ? new Date(init.art_date_commit) : null;
        this.art_date_last_update = init.art_date_last_update ? new Date(init.art_date_last_update) : null;
        this.art_etat = (init.art_etat === '1');
        this.art_suppression = (init.art_suppression === '1');
    }

    get computed_name(): string {
        return this.art_code && this.art_code != '' ? `[${this.art_code}] ${this.art_libelle}` : `${this.art_libelle}`;
    }

    toJSON() {
        const article: any = {};
        Object.assign(article, this);
        article.art_date_commit = this.art_date_commit ? moment(this.art_date_commit).format('YYYY-MM-DD') : null;
        article.art_date_last_update = this.art_date_last_update ? moment(this.art_date_last_update).format('YYYY-MM-DD') : null;
        article.art_etat = this.art_etat ? '1' : '0';
        article.art_suppression = this.art_suppression ? '1' : '0';

        return JSON.stringify(article);
    }

    checkIsValid(): {valid: boolean, fields: String[]} {
        const requiredFields = [
            {key: 'art_libelle', libelle: "Libellé"},
            {key: 'art_aca_id', libelle: "Catégorie"},            
            {key: 'art_prix_unitaire_ht', libelle: "P.U. HT"},
            {key: 'art_taux_tva', libelle: "Taux T.V.A."},
            {key: 'art_atq_id', libelle: "Type d'unité"},
        ];

        let valid = true;
        let invalidFields = [];
        
        requiredFields.forEach(field => {
            if (this[field.key] === undefined || this[field.key] === null || this[field.key] === '') {
                valid = false;
                invalidFields.push(field.libelle);
            }
        });

        return {valid: valid, fields: invalidFields};
    }
}